export default __webpack_public_path__ + "static/media/testimonial1-150x150.cc719c81.png";